export const formDataMapper = (data: any, formData: FormData = new FormData(), parentKey: string = ''): FormData => {
    if (data && typeof data === 'object' && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            const value = data[key];
            const formKey = parentKey ? `${parentKey}[${key}]` : key;

            if (value === null || value === undefined) {
                return;
            }

            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    formDataMapper(item, formData, `${formKey}[${index}]`);
                });
            } else if (value && typeof value === 'object' && !(value instanceof File)) {
                formDataMapper(value, formData, formKey);
            } else {
                formData.append(formKey, value);
            }
        });
    } else {
        formData.append(parentKey, data);
    }
    return formData;
};